import { render, staticRenderFns } from "./editarBairro.vue?vue&type=template&id=799de9c9"
import script from "./editarBairro.vue?vue&type=script&lang=js"
export * from "./editarBairro.vue?vue&type=script&lang=js"
import style0 from "./editarBairro.vue?vue&type=style&index=0&id=799de9c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports